import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

/**
 * AlertService
 */
@Injectable({
	providedIn: 'root'
})
export class AlertService {
	constructor(router: Router) {
		router.events.subscribe((event: NavigationStart) => {
			if (event instanceof NavigationStart) {
				this.clearErrors();
			}
		});
	}
	public errors: string[] = [];

	public authorizationError: BehaviorSubject<unknown> = new BehaviorSubject(null);

	addError(error: string): void {
		if (!this.errors.includes(error)) {
			this.errors.push(error);
		}
	}

	removeError(index: number): void {
		this.errors.splice(index, 1);
		this.authorizationError.next(null);
	}

	clearErrors(): void {
		this.errors = [];
	}
}
